module.exports = __webpack_public_path__ + "assets/img/vtuber-app3.daee03a2.png";